import { IMGIX_PARAMS } from 'common/constants';
import { StoryMediaQuery } from 'types/story';

export const bgImage = url => ({ backgroundImage: `url('${url}')` });

export const getBgUrlWithImgIx = (url: string, p: { mq: StoryMediaQuery['config'] }) => {
	let result = url;

	if (url.match('imgix.net') && url.match('.gif') === null && url.match('.svg') === null && url !== 'none') {
		const start = url.substr(0, url.length - 1);
		const end = url.substr(url.length - 1);
		const hasParams = url.match(/\?/);
		const mobileSize = p.mq.mobile.maxWidth ?? 0;

		const params = window.innerWidth <= mobileSize ? IMGIX_PARAMS.MOBILE : IMGIX_PARAMS.DESKTOP;
		result = `${start}${hasParams ? '&' : '?'}${params}${end}`;
	}

	return result;
};
